import React, {useCallback, useEffect, useRef, useState} from 'react';
import 'components/UserTable/table.scss';
import {ReactComponent as AddIcon} from 'assets/svgs/categories/add.svg';
import {ReactComponent as DeleteIcon} from 'assets/svgs/categories/delete.svg';
import messages from './messages';
import DeleteConfirm from './DeleteConfirm';

export default ({
  onCancel,
  selectedItem,
  setUpdating,
  onRefresh,
  setDeleteConfirm,
  deleteConfirm,
  setSelectOpen,
  targetSelectIsOpen,
  createUpdateItem,
  team,
  tableData,
  centerizeForm,
  setFormMargin,
  formMargin,
  targetRole,
  items,
  createUpdateStatus,
  errorMessage,
  setErrorMessage,
}) => {
  const hasMiddle = !!tableData.inputs.middle;
  const inputRightLength = Object.keys(tableData.inputs.right).length;
  const {validations} = tableData;
  const userForm = useRef();
  const [item, setItem] = useState(tableData.firstInitItemState(selectedItem));
  const [validationErrors, setValidationErrors] = useState(
    tableData.validationErrors
  );
  useEffect(() => {
    const {error, createFailed, submitting, createSuccess} = createUpdateStatus;

    if (error && createFailed) {
      setUpdating(false);
      setErrorMessage(error);
    } else if (!submitting && createSuccess) {
      setErrorMessage('');
      updateState();
    }
  }, [createUpdateStatus]);

  useEffect(() => {
    setItem(tableData.resetOnSelectItem(selectedItem, team));
  }, [selectedItem]);

  useEffect(() => {
    if (item._id) {
      const margin = centerizeForm(userForm.current.offsetWidth);
      setFormMargin(margin);
      userForm.current.style.marginRight = `${margin}px`;
    }
  }, [item._id]);

  const handleChange = useCallback((key, value) => {
    setItem((oldItem) => {
      const newItem = {...oldItem};
      newItem[key] = value;
      return newItem;
    });
  }, []);

  const validateField = (key, value) => {
    const validationForKey = validations[key];
    const newValidationErrors = {...validationErrors};

    if (!validationForKey.validate(value)) {
      newValidationErrors[key] = {
        isValid: false,
        error: validationForKey.error,
      };
      setValidationErrors(newValidationErrors);
    } else if (!validationErrors[key].isValid) {
      newValidationErrors[key] = {isValid: true};
      setValidationErrors(newValidationErrors);
    }
  };

  const checkForValidation = () => {
    let valid = true;
    const newValidationErrors = {...validationErrors};
    Object.keys(item).forEach((key) => {
      const validationForKey = validations[key];
      const value = item[key] ? item[key].toString() : '';

      if (validationForKey) {
        if (!validationForKey.validate(value)) {
          valid = false;

          newValidationErrors[key] = {
            isValid: false,
            error: validationForKey.error,
          };
        } else {
          newValidationErrors[key] = {
            isValid: true,
            error: '',
          };
        }
      }
      setValidationErrors(newValidationErrors);
    });

    return valid;
  };

  const updateState = useCallback(() => {
    onCancel();
    setTimeout(() => {
      setUpdating(false);
      onRefresh();
    }, 1000);
  }, []);

  const onAddMember = async (event) => {
    if (event !== undefined && event.preventDefault) {
      event.preventDefault();
    }
    // const isValid = checkForValidation();

    // if (!isValid) return;
    const updatedItem = tableData.onAddMemberItemRemap(item, team);
    setUpdating(true);
    createUpdateItem(updatedItem);
  };

  const onDeleteMember = useCallback(
    (event) => {
      event.preventDefault();
      if (item._id && item._id !== 'new_user' && item.isExistingUser !== true) {
        setDeleteConfirm(true);
      } else {
        onCancel(true, item._id);
      }
    },
    [item._id, item.isExistingUser]
  );

  const confirmDeleteMember = () => {
    setDeleteConfirm(false);
    setUpdating(true);
    const fullObject = tableData.onConfirmDeleteMemberItemRemap(item, team);
    createUpdateItem(fullObject);
    updateState();
  };

  const renderInput = (Input, key, i, keys, config, direction) => {
    if (item._id) {
      if (direction === messages.middle) {
        return (
          <Input
            key={key}
            item={item}
            handleChange={handleChange}
            {...config.componentProps}
          />
        );
      }

      if (config.componentName === 'PeriodInput') {
        return (
          <div
            key={key}
            className={`${i < keys.length - 1 ? 'mb-3' : ''} input-box ${
              config.containerClassess || ''
            }`}
          >
            <Input
              item={item}
              handleChange={handleChange}
              setSelectOpen={setSelectOpen}
              targetSelectIsOpen={targetSelectIsOpen}
              lastItemPeriod={items.at(-2) ? items.at(-2).period : {}}
            />
          </div>
        );
      }

      if (config.type === messages.select || config.type === messages.date) {
        return (
          <div
            key={key}
            className={`${i < keys.length - 1 ? 'mb-3' : ''} input-box ${
              config.containerClassess || ''
            }`}
          >
            <Input
              item={item}
              name={config.name}
              handleChange={handleChange}
              setSelectOpen={setSelectOpen}
              targetSelectIsOpen={targetSelectIsOpen}
              targetRole={targetRole}
              {...config.componentProps}
            />
          </div>
        );
      }

      return (
        <div
          key={key}
          className={`${i < keys.length - 1 ? 'mb-3' : ''} input-box ${
            config.containerClassess || ''
          }`}
        >
          <Input
            item={item}
            handleChange={handleChange}
            {...config.componentProps}
          />
        </div>
      );
    }
  };
  console.log('edit form item', item);
  const renderList = (direction) => {
    const targetObj = tableData.inputs[direction];
    if (targetObj) {
      const keys = Object.keys(targetObj);
      return keys.map((key, i) => {
        const config = targetObj[key];
        const Input = config.component;
        return renderInput(Input, key, i, keys, config, direction);
      });
    }
  };
  return (
    <div>
      <div className="d-flex flex-column">
        <div
          className="d-flex justify-content-center pt-4 pb-4 form-container"
          ref={userForm}
        >
          <div
            className="d-flex flex-column"
            style={{
              marginRight: inputRightLength === 1 ? 40 : 0,
            }}
          >
            {renderList('right')}
          </div>
          {renderList('middle')}
          <div className="d-flex flex-column position-relative">
            {!deleteConfirm && (
              <div
                className="add-cat-row position-absolute delete-action-button"
                style={{top: hasMiddle ? 6 : 8, right: hasMiddle ? -20 : -60}}
              >
                <button
                  type="button"
                  onClick={onDeleteMember}
                  className="btn-link position-absolute"
                >
                  <DeleteIcon />
                </button>
              </div>
            )}
            <div className="add-cat-row position-absolute add-action-button">
              <button
                type="button"
                onClick={onAddMember}
                className="btn-link position-absolute"
              >
                <AddIcon />
              </button>
            </div>
            {renderList('left')}
          </div>
        </div>
        {deleteConfirm && (
          <DeleteConfirm
            formMargin={formMargin}
            confirmDeleteMember={confirmDeleteMember}
            setDeleteConfirm={setDeleteConfirm}
          />
        )}
        {errorMessage && item._id === createUpdateStatus.id && (
          <div className="error-message">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};
